import './AreaIndicatorChart.css';

import React, { useEffect, useState } from 'react';
import { generateSelectField, toLocaleDateTime } from '../../../../b2b-common/helpers';
import Counter from '../../../../b2b-common/Counter';
import ObjectiveTypeIcon from '../../objectives/ObjectiveTypeIcon';
import useB2BTranslation from '../../../../b2b-common/hooks/useB2BTranslation';
import { getCurrentObjective } from '../../helper';

const AreaIndicatorChart = ({ areaIndicator, ChartFactory, indicatorType, createObjectives, getAllSamplesCount }) => {
    const { t } = useB2BTranslation('b2b-plans');

    const [currentAreaIndicator, setCurrentAreaIndicator] = useState(areaIndicator);
    const [currentAreaIndicatorObjectives, setCurrentAreaIndicatorObjectives] = useState(null);
    const [currentObjective, setCurrentObjective] = useState(null);

    useEffect(() => {
        setCurrentAreaIndicator(areaIndicator);
        const objectives = createObjectives ? createObjectives(areaIndicator.objectiveDTOs) : areaIndicator.objectiveDTOs;
        setCurrentAreaIndicatorObjectives(objectives);
        setCurrentObjective(getCurrentObjective(objectives));
    }, [areaIndicator, createObjectives]);

    const objectivesSelectContent = currentAreaIndicatorObjectives ? currentAreaIndicatorObjectives.map((objective, index) => ({
        label: toLocaleDateTime(objective.startDate, false) + ' - ' + toLocaleDateTime(objective.endDate),
        key: index,
        value: index,
        default: index === currentAreaIndicatorObjectives.indexOf(currentObjective) ? index : null
    })) : [];

    const handleChangeObjective = (event) => {
        const objectiveIndex = event.target.value;
        setCurrentObjective(currentAreaIndicatorObjectives[objectiveIndex]);
    };

    if (!currentObjective) {
        return null;
    }

    const allSamplesCount = getAllSamplesCount ? getAllSamplesCount(currentObjective) : currentObjective.samplesPerObjective.length;

    return (
        <>
            {currentObjective && (
                <div className='area-indicator-chart'>
                    <div className='area-indicator-chart-objectives-header'>
                        {(currentAreaIndicator.indicatorDTO.indicatorDTOType === indicatorType) && (
                            <>
                                {generateSelectField(objectivesSelectContent, {
                                    label: `${t('Objectives')} [${currentAreaIndicatorObjectives.length}]`,
                                    className: 'area-indicator-chart-objectives-select-quant-qual',
                                    value: currentAreaIndicatorObjectives ? currentAreaIndicatorObjectives.indexOf(currentObjective) : 0,
                                    onChange: handleChangeObjective
                                })}
                                <div className='area-indicator-chart-objectives-quant-qual-metrics'>
                                    <ObjectiveTypeIcon objective={currentObjective} />
                                    <Counter label={t('Samples')} count={allSamplesCount} minDigits={2} />
                                </div>
                            </>
                        )}
                    </div>
                    <div className='area-indicator-chart-selected-objective'>
                        {currentAreaIndicator.indicatorDTO.indicatorDTOType === indicatorType && (
                            <ChartFactory indicatorDTO={currentAreaIndicator.indicatorDTO} objective={currentObjective} />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default AreaIndicatorChart;